/** @format */

import {Circle1, Circle2, Circle3, Root} from './styles';

interface Props {
  animate: boolean;
}

const DigitalCastIcon = ({animate}: Props) => {
  return (
    <Root animate={animate}>
      <Circle1 animate={animate} />
      <Circle2 animate={animate} />
      <Circle3 animate={animate} />
    </Root>
  );
};

export {DigitalCastIcon};
